import React from 'react';
const Config = {
  url: window.location.origin,
  userName: '',
  passWord: '',
};

if (ReactIsInDevelomentMode()) {
  Config.url = '';
  Config.userName = 'admin';
  Config.passWord = 'Solutions!';  
  // Config.userName = 'minh.tran@jensen.com.au';
  // Config.passWord = 'minh.tran@jensen.com.au';
  // Config.userName = 'minh@gmail.com';
  // Config.passWord = 'jds';
}

export default Config;

export function ReactIsInDevelomentMode() {
  return '_self' in React.createElement('div');
}
